import { flatten } from 'lodash/fp';
import { API_URL } from '../../../app-config/constants';
import type ObjectiveClippy from '../../../types/ObjectiveClippy';
import { get } from '../request';

getAllRelevant.operation = 'READ';
export function getAllRelevant({
    userId,
    startDate,
    endDate,
}: {
    userId: string;
    startDate?: string;
    endDate?: string;
}) {
    return get<ObjectiveClippy[]>(`${API_URL}/objective-cycles/all/objectives/relevant`, {
        getData: { userId, startDate, endDate },
    });
}

list.operation = 'READ';
export function list(cycleId: string) {
    return get<ObjectiveClippy[]>(`${API_URL}/objective-cycles/${cycleId}/objectives/list`);
}

listCycles.operation = 'READ';
export function listCycles(cycleIds: string[]) {
    const requests = cycleIds.map(cycleId =>
        get<ObjectiveClippy[]>(`${API_URL}/objective-cycles/${cycleId}/objectives/list`)
    );
    return Promise.all(requests).then(flatten);
}

listAll.operation = 'READ';
export function listAll() {
    return get<ObjectiveClippy[]>(`${API_URL}/objective-cycles/all/objectives/list`);
}
